// Module
var code = "<ng-include ng-repeat=\"pinField in vm.filterablePinFields | orderBy: 'order'\" ng-hide=\"pinField.is_hidden\" src=\"::vm.buildTemplateUrl(pinField)\"> </ng-include> ";
// Exports
module.exports = code;